const soilCropFertilizerAdvice = {
  'Maize': {
    loamy: 'Apply NPK 20:10:10 at planting and top-dress with urea after 3 weeks.',
    sandy: 'Use compost + NPK 20:10:10 to improve fertility and moisture retention.',
    clayey: 'Use well-decomposed organic matter + NPK 20:10:10 for better aeration.',
    acidic: 'Apply lime to neutralize soil, then use NPK 20:10:10.',
    waterlogged: 'Avoid; if necessary, plant on ridges and apply NPK 20:10:10.',
  },
  'Cassava': {
    loamy: 'Use NPK 15:15:15 at planting for optimal root development.',
    sandy: 'Apply compost or manure + NPK 15:15:15 to enrich poor soil.',
    clayey: 'Use raised beds + organic compost and NPK 15:15:15.',
    acidic: 'Apply lime first; then NPK 15:15:15 after 2 weeks.',
    waterlogged: 'Plant on mounds and use light NPK 15:15:15 after 1 month.',
  },
  'Rice': {
    loamy: 'Use Urea and NPK 20:10:10 at tillering and panicle initiation.',
    sandy: 'Apply manure + split doses of NPK 20:10:10.',
    clayey: 'Ensure puddling, then apply Urea + NPK 20:10:10.',
    acidic: 'Lime + NPK 20:10:10 and SSP are recommended.',
    waterlogged: 'Use flood-tolerant variety with basal NPK 20:10:10.',
  },
  'Yam': {
    loamy: 'Apply compost or NPK 15:15:15 during mounding.',
    sandy: 'Add organic manure + NPK 15:15:15 to improve tuber size.',
    clayey: 'Raise heaps and apply NPK 15:15:15 moderately.',
    acidic: 'Lime + organic manure before applying NPK 15:15:15.',
    waterlogged: 'Avoid; if used, raise ridges and use light NPK.',
  },
  'Tomato': {
    loamy: 'NPK 20:10:10 at transplanting and flowering stages.',
    sandy: 'Use compost and split application of NPK 20:10:10.',
    clayey: 'Improve drainage + apply NPK 20:10:10.',
    acidic: 'Lime + NPK 20:10:10 after 2 weeks.',
    waterlogged: 'Avoid; use raised beds with NPK 20:10:10.',
  },
  'Groundnut': {
    loamy: 'Apply SSP and light NPK 15:15:15 at flowering.',
    sandy: 'SSP + compost to boost flowering and pod filling.',
    clayey: 'Ensure aeration and apply SSP + NPK 15:15:15.',
    acidic: 'Lime + SSP before planting.',
    waterlogged: 'Avoid as it reduces yield significantly.',
  },
  'Sorghum': {
    loamy: 'NPK 20:10:10 at sowing and tillering.',
    sandy: 'Add compost + split NPK 20:10:10.',
    clayey: 'Moderate NPK 20:10:10 + organic manure.',
    acidic: 'Apply lime then NPK 20:10:10.',
    waterlogged: 'Use raised beds and avoid excessive nitrogen.',
  },
  'Millet': {
    loamy: 'Apply NPK 15:15:15 after 2–3 weeks of growth.',
    sandy: 'Use compost and light NPK 15:15:15.',
    clayey: 'Loosen soil + NPK 15:15:15.',
    acidic: 'Apply lime and follow with NPK 15:15:15.',
    waterlogged: 'Avoid or plant in raised rows.',
  },
  'Cocoa': {
    loamy: 'Use compost + NPK 20:10:10 in split doses.',
    sandy: 'Heavy organic mulch + compost before NPK 20:10:10.',
    clayey: 'Improve drainage, then use compost + NPK 20:10:10.',
    acidic: 'Lime soil before planting, then NPK 20:10:10 yearly.',
    waterlogged: 'Avoid or provide drainage, apply compost only.',
  },
  'Oil Palm': {
    loamy: 'Apply NPKMg 12:12:17 + 2MgO yearly.',
    sandy: 'Use compost + NPKMg 12:12:17 + 2MgO in 2 splits.',
    clayey: 'Add gypsum and apply NPKMg 12:12:17 + 2MgO.',
    acidic: 'Lime soil + use NPKMg 12:12:17 + 2MgO.',
    waterlogged: 'Plant on ridges and apply fertilizer after drainage.',
  }
};

export default soilCropFertilizerAdvice;
